<template>
    <div class="target-obj" v-loading="loading">
        <Paper class="target-obj-paper">
            <el-tabs class="target-list-tab-pane" v-model="activeTabs">
                <el-tab-pane label="目标对象" name="theList" ref="myPane">
                    <list-layout-paper>
                        <template slot="header-button">
                            <!-- 按钮显示：审批状态=草稿/驳回/撤回（保存、提交审批） -->
                            <!-- "3": "审批中", "5": "审批驳回", "6": "撤回", "4": "审批通过", "7": "作废", "1": "草稿", "2": "待审批" -->
                            <lotsButton
                                type="primary"
                                size="mini"
                                title="请先选择一个岗位"
                                @click="createOpera"
                                :disabled="!currentGroupName"
                                v-if="
                                    applyData.approvalStatus === 1 ||
                                    applyData.approvalStatus === 5 ||
                                    applyData.approvalStatus === 6
                                "
                            >
                                新增用户
                            </lotsButton>
                        </template>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="submissionApplicationTargetObj"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                height="500px"
                                :tableData="tableList.totalData"
                                :actions="config.actions"
                                :control="true"
                                :allowRowClick="false"
                                highlight-current-row
                                @current-change="handleCurrentChange"
                                @btn-event="handleActive"
                            >
                                <template v-slot:col-append="{ item, row }">
                                    <span v-if="['groupName'].includes(item.prop)">
                                        <el-radio v-model="currentGroupName" class="currentGroupNameRadio" :label="row.groupName"></el-radio>
                                    </span>
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
            </el-tabs>
        </Paper>

        <!-- 导入弹窗 -->
        <addFileDialog
            ref="fileDialogRef"
            :config="importConfig"
            @uploadSuccessHandle="uploadSuccessHandle"
          >
        </addFileDialog>

        <advanceUser ref='advanceUserRef' @confirm="detaliSearchSure"></advanceUser>
    </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from '@vue/composition-api';
import { Message } from 'element-ui';
import { handleDictionaryDataString, formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getGroupInfoList, saveObjApi, exportApi, getUserOrg } from '@/modules/mdm/api/targetModdeules/subMissionApplication.js';
import { config as configStatic } from './targetObj';
import advanceUser from '@/components/lots/otpAdvanceUser';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import { importConfigOpt } from './import';
import _ from 'lodash';
import store from '@/store/index';

export default {
    name: 'targetObj',
    components: {
        Paper,
        listLayoutPaper,
        lotsButton,
        editTableBox,
        lotsPagination,
        advanceUser,
        addFileDialog
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(configStatic);
        // 加载中
        const loading = ref(false);
        // 目标对象tab
        const activeTabs = ref('theList');
        // 打开的详情tab页集
        const tabList = ref([]);
        // 当前选中的分组
        const currentGroupId = ref('');
        const currentGroupName = ref('');
        const applyData = ref(props.data || {});
        // 添加对props.data的监听
        watch(
            () => props.data,
            (newData, oldData) => {
                applyData.value = newData;
                if (newData.applyCode || (newData.isRefresh !== oldData?.isRefresh)) {
                    tableList.getList();
                }
            },
            { deep: true } // 深度监听，确保对象内部属性变化也能被捕获
        );

        // 新增/编辑 操作
        const createOpera = () => {
            setupContext.refs.advanceUserRef.show(true, '', [], orgIds.value);
        };

        const detaliSearchSure = (list) => {
            const row = _.cloneDeep(applyData.value);
            const params = {
                applyCode: row.applyCode,
                deptCode: row.deptCode,
                goalTypeCodes: row.goalTypeCodes,
                groupName: currentGroupName.value,
                respUserList: []
            };
            list.map(item => {
                params.respUserList.push({
                    userCode: item.userCode,
                    userName: item.userName
                });
            });
            saveOpera(params);
        };

        // 保存操作
        const saveOpera = (data) => {
            const params = _.cloneDeep(data);
            loading.value = true;
            saveObjApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('保存成功');
                    refreshList();
                }
            }).finally(() => {
                loading.value = false;
            });
        };

        const searchDataFormat = (condition) => {
            condition.applyCode = applyData.value.applyCode;
            condition.goalTypeCodes = applyData.value.goalTypeCodes;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    if (res.data.list && res.data.list.length) {
                        this.totalData.value = res.data.list.map(v => {
                            return {
                                edit: -3,
                                approvalStatus: applyData.value.approvalStatus,
                                ...v
                            };
                        });
                        setupContext.root.$nextTick(() => {
                            if (currentGroupId.value) {
                                // 触发保存成功事件，更新父组件数据
                                setupContext.emit('updateCurrentRow', { groupName: currentGroupName.value, groupId: currentGroupId.value });
                            } else {
                                // 默认选中第一行
                                currentGroupId.value = this.totalData.value[0].id;
                                currentGroupName.value = this.totalData.value[0].groupName;
                                // 触发保存成功事件，更新父组件数据
                                setupContext.refs.editTableBox.$refs.moduleTable.setCurrentRow(this.totalData.value[0]);
                            }
                            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                        });
                    }
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getGroupInfoList // 查询接口
            }
        });

        // 切换当前选中行
        const handleCurrentChange = (row) => {
            if (row && row.id) {
                currentGroupId.value = row.id;
                currentGroupName.value = row.groupName;
                setupContext.emit('updateCurrentRow', { groupName: currentGroupName.value, groupId: currentGroupId.value });
            }
        };

        // 操作项
        const handleActive = (row, event) => {
            // 导入
            if (event === 'import') {
                // exportOpera();
                importOpera(row);
            }
            // 导出
            if (event === 'export') {
                exportOpera(row);
            }
        };

        const importConfig = ref({});
        // 打开导入弹窗
        const importOpera = (row) => {
            importConfigOpt.downParams.groupId = row.id;
            importConfigOpt.downParams.groupName = row.groupName;
            importConfigOpt.downParams.applyCode = applyData.value.applyCode;
            importConfigOpt.downParams.exportType = '1';
            importConfigOpt.beforeRequest = (params) => {
                params.groupId = row.id;
                params.groupName = row.groupName;
                params.applyCode = applyData.value.applyCode;
                return params;
            };
            importConfig.value = importConfigOpt;
            setupContext.refs.fileDialogRef.openImport();
        };

        const uploadSuccessHandle = (data) => {
            refreshList();
        };

        // 导出
        const exportOpera = (row) => {
            const excelTitleList = config.columns?.filter(item => !item.hiddenColumn).map(item => ({
                name: item.label,
                property: item.prop
            })) ?? [];
            const { value } = tableList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            // 配置了那些字段就传那些
            newData.excelTitleList = excelTitleList;
            newData.applyCode = applyData.value.applyCode;
            newData.exportType = '2';
            newData.groupId = currentGroupId.value;
            newData.groupName = currentGroupName.value;
            exportApi(newData).then(res => {
                if (+res.code === 0) {
                    Message.success('请稍后到右上角用户文件列表中下载');
                }
            });
        };

        // 获取用户组织链
        const orgIds = ref([]);
        const getOrgIds = () => {
            const { orgCode } = store.getters.user;
            getUserOrg({ orgCode }).then(res => {
                if (+res.code === 0) {
                    orgIds.value = res.data.fullCode ? res.data.fullCode.split('_') : [];
                }
            });
        };

        const refreshList = () => {
            tableList.getList();
        };

        onMounted(() => {
            getOrgIds();
            // tableList.getList();
        });

        return {
            tableList,
            config,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleActive,
            activeTabs,
            tabList,
            createOpera,
            detaliSearchSure,
            importConfig,
            handleCurrentChange,
            applyData,
            loading,
            currentGroupId,
            currentGroupName,
            uploadSuccessHandle,
            refreshList
        };
    }
};
</script>

<style lang="less" >
    .list-dropdown.el-dropdown {
        color: #fff;
    }

    .list-dropdown-menu {
        background-color: #fff;
    }

    .target-obj {
    width: 100%;

    .target-obj-paper {
        height: 100%;

        .header-button {
            height: 28px;
        }
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .target-list-tab-pane {
        .el-tabs__item {
            height: 32px;
            line-height: 32px;
        }
    }

    .target-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .list-layout .list-header {
        justify-content: flex-start;
        padding: 5px 0 5px 0;
    }

    .list-layout .list-header .header-search {
        flex: none;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .target-obj-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content {
        min-width: auto;
    }

    .layout-content.target-obj-paper {
        padding: 0px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.target-obj-list-dropdown-menu {
    background-color: #fff;
}

.column-config_title {
    font-size: 14px;
}
</style>
